<div class="container" fxLayout="row wrap" fxLayoutAlign="space-between start">
  <div class="configuration-panel" fxLayout="column" fxFlex="100" [fxFlex.gt-sm]="collapsed ? 100 : 64">
    <button fxShow="true" fxShow.lt-md="false" class="collapse" mat-mini-fab (click)="toggleCollapse()" [matTooltip]="collapsed ? 'Expand' : 'Collapse'">
      <mat-icon *ngIf="collapsed">keyboard_double_arrow_left</mat-icon>
      <mat-icon *ngIf="!collapsed">keyboard_double_arrow_right</mat-icon>
    </button>
    <mat-card *ngIf="situConnectId" class="mat-card-inline-sm">
      <mat-card-content style="position: relative;">
        <situ-view-readonly fxFlex *ngIf="quickViewProductName === productNames.Panorama" [routeParams]="quickViewReportedSituLinkParams"></situ-view-readonly>
        <div *ngIf="quickViewProductName === productNames.Facade" fxFlex="100" class="w-100" fxLayoutAlign="start center">
          <img style="width: 100%" [src]="getFacadeImageUrl(situConnectId)">
        </div>
        <div  class="source-artifacts-overlay" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="5px">
          <button class="link" [disabled]="selectedSituConnect?.connectType === 'draftsitulinkpanoramas'" [style.color]="getIconColor('draftsitulinkpanoramas')" (click)="upgrade('draftsitulinkpanoramas')" color="accent" mat-icon-button matTooltip="Create {{ getConnectTypeTooltip('draftsitulinkpanoramas') }} version of this situCONNECT">
            <mat-icon>panorama</mat-icon>
          </button>
          <button class="link" [disabled]="selectedSituConnect?.connectType === 'situlinkpanoramas'" [style.color]="getIconColor('situlinkpanoramas')" (click)="upgrade('situlinkpanoramas')" color="accent" mat-icon-button matTooltip="Create {{ getConnectTypeTooltip('situlinkpanoramas') }} version of this situCONNECT">
            <mat-icon class="link">panorama</mat-icon>
          </button>
          <button class="link" [disabled]="selectedSituConnect?.connectType === 'facade'" [style.color]="getIconColor('facade')" (click)="upgrade('facade')" color="accent" mat-icon-button matTooltip="Create {{ getConnectTypeTooltip('facade') }} version of this situCONNECT">
            <mat-icon class="link">image</mat-icon>
          </button>
          <button (click)="share()" color="accent" mat-mini-fab matTooltip="Share situLINK">
            <mat-icon class="link">share</mat-icon>
          </button>
          <source-artifacts-menu colourOverride="info" [isSituUser]="isSituUser" [isAdmin]="isAdmin" [isDarkMode]="isDarkMode" *ngIf="baseIngredients" [sourceArtifacts]="baseIngredients"></source-artifacts-menu>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="mat-card-inline-sm">
      <mat-card-content fxLayout="column" fxLayoutAlign="start start">
        <mat-stepper #stepper orientation="vertical" [linear]="true" fxFlexFill>
          <mat-step [stepControl]="renderType" [label]="renderType ? 'Select a Connect Type - ' + getConnectTypeTooltip(renderType) : 'Select a Connect Type'">
            <div class="selected-type" fxLayout="row" fxLayoutAlign="center start">
              <span *ngIf="renderType === 'draftsitulinkpanoramas'">{{getConnectTypeTooltip('draftsitulinkpanoramas')}}</span>
              <span *ngIf="renderType === 'situlinkpanoramas'">{{getConnectTypeTooltip('situlinkpanoramas')}}</span>
              <span *ngIf="renderType === 'hdsitulinkpanoramas'">{{getConnectTypeTooltip('hdsitulinkpanoramas')}}</span>
              <span *ngIf="renderType === 'facade'">{{getConnectTypeTooltip('facade')}}</span>
              <span *ngIf="renderType === 'hdfacade'">{{getConnectTypeTooltip('hdfacade')}}</span>
            </div>
            <div class="m-t-20 m-b-20" fxLayout="row wrap" fxLayoutAlign="space-around center">
              <!-- Draft SituLink Panoramas -->
              <div fxLayout="column" fxLayoutAlign="center center">
                <mat-icon 
                  class="link render-type-icon-4" 
                  [ngClass.lt-sm]="'render-type-icon-3'" 
                  [style.color]="getIconColor('draftsitulinkpanoramas')" 
                  [class.render-type-selected]="renderType === 'draftsitulinkpanoramas'" 
                  (click)="renderType = 'draftsitulinkpanoramas'"
                  [matTooltip]="getConnectTypeTooltip('draftsitulinkpanoramas')">
                  {{ getIconType('draftsitulinkpanoramas') }}
                </mat-icon>
                <span class="icon-label">{{getConnectTypeTooltip('draftsitulinkpanoramas')}}</span>
              </div>
              <!-- SituLink Panoramas -->
              <div fxLayout="column" fxLayoutAlign="center center">
                <mat-icon 
                  class="link render-type-icon-4" 
                  [ngClass.lt-sm]="'render-type-icon-3'" 
                  [style.color]="getIconColor('situlinkpanoramas')" 
                  [class.render-type-selected]="renderType === 'situlinkpanoramas'" 
                  (click)="renderType = 'situlinkpanoramas'" 
                  [matTooltip]="getConnectTypeTooltip('situlinkpanoramas')">
                  {{ getIconType('situlinkpanoramas') }}
                </mat-icon>
                <span class="icon-label">{{getConnectTypeTooltip('situlinkpanoramas')}}</span>
              </div>
              <!-- <mat-icon 
                class="link render-type-icon-4 render-type-selected" 
                [ngClass.lt-sm]="'render-type-icon-3'" 
                [style.color]="getIconColor('hdsitulinkpanoramas')" 
                [class.render-type-selected]="renderType === 'hdsitulinkpanoramas'" 
                matTooltip="HD SituLink Panoramas">
                {{ getIconType('hdsitulinkpanoramas') }}
              </mat-icon> -->
              <!-- <mat-icon 
                class="link render-type-icon-4" 
                [ngClass.lt-sm]="'render-type-icon-3'" 
                [style.color]="getIconColor('hdsitulinkpanoramas')" 
                [class.render-type-selected]="renderType === 'hdsitulinkpanoramas'" 
                (click)="renderType = 'hdsitulinkpanoramas'"
                matTooltip="HD SituLink Panoramas">
                {{ getIconType('hdsitulinkpanoramas') }}
              </mat-icon> -->
              <div fxLayout="column" fxLayoutAlign="center center">
                <mat-icon 
                  class="link render-type-icon-4" 
                  [ngClass.lt-sm]="'render-type-icon-3'" 
                  [style.color]="getIconColor('facade')" 
                  [class.render-type-selected]="renderType === 'facade'" 
                  (click)="renderType = 'facade'" 
                  [matTooltip]="getConnectTypeTooltip('facade')">
                  {{ getIconType('facade') }}
                </mat-icon>
                <span class="icon-label">{{getConnectTypeTooltip('facade')}}</span>
              </div>
              <!-- <mat-icon 
                class="link render-type-icon-4" 
                [ngClass.lt-sm]="'render-type-icon-3'" 
                [style.color]="getIconColor('hdfacade')" 
                [class.render-type-selected]="renderType === 'hdfacade'" 
                (click)="renderType = 'hdfacade'"
                matTooltip="HD Facade">
                {{ getIconType('hdfacade') }}
              </mat-icon> -->
            </div>
            <div style="margin-top: 50px;">
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext color="accent" [disabled]="!renderType" (click)="situConnectId = undefined">Next</button>
            </div>
          </mat-step>          
          <mat-step class="p-t-20 p-b-20" [stepControl]="firstFormGroup" [label]="customerName && customerReference ? 'Customer - ' + customerName + ' ' + customerReference : 'Customer'">
            <form class="m-t-20 m-b-20" [formGroup]="firstFormGroup">
              <mat-form-field>
                <mat-label>Customer Name</mat-label>
                <input matInput placeholder="Customer Name" formControlName="customerName" required>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Customer Reference</mat-label>
                <input matInput placeholder="Customer Reference" formControlName="customerReference" required>
              </mat-form-field>
              <div>
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button matStepperNext color="accent" [disabled]="!firstFormGroup?.valid" (click)="situConnectId = undefined">Next</button>
              </div>
            </form>
          </mat-step>
          <mat-step [stepControl]="ifcFile?.fileName"  [label]="ifcFile?.fileName ? 'Home - ' + ifcFile?.fileName?.split('\\').pop().split('/').pop() : 'Home'">
            <input fxHide #filePicker class="file-input" attr.id="IFCFile_" type="file" accept=".ifc" (change)="onFileChosen($event)" />
            <mat-form-field class="m-t-20 m-b-20">
              <mat-label>Choose a file</mat-label>
              <input matInput type="text" [value]="ifcFile?.fileName?.split('\\').pop().split('/').pop()" (click)="filePicker.click();" [readonly]="true">
              <button matSuffix mat-icon-button aria-label="Upload" (click)="filePicker.click();">
                <mat-icon>attach_file</mat-icon>
              </button>
              <button matSuffix mat-icon-button aria-label="remove" *ngIf="ifcFile?.fileName" (click)="onRemoveIFCFile();">
                <mat-icon>clear</mat-icon>
              </button>
            </mat-form-field>
            <div>
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext color="accent" [disabled]="!ifcFile?.fileName" (click)="situConnectId = undefined">Next</button>
            </div>
          </mat-step>
          <mat-step [stepControl]="styleTemplateId" label="Style">
            <style-config class="m-t-20 m-b-20" [canEditTemplates]="isAdmin || isSituUser" [canAddTemplates]="isAdmin || isSituUser" 
              [backend]="false"
              [product]="connectProductName"
              (onStyleTemplateChange)="onStyleTemplateIdUpdates($event)">
            </style-config>
            <div>
              <button mat-button matStepperPrevious>Back</button>
              <button mat-button matStepperNext color="accent" [disabled]="!styleTemplateId" (click)="situConnectId = undefined">Next</button>
            </div>
          </mat-step>
          <mat-step>
            <ng-template matStepLabel>Create</ng-template>
            <div class="m-t-20 m-b-20" fxLayout="row" fxLayoutAlign="end center">
              <div class="h-100" fxFlex="100" fxLayout="row" fxLayoutAlign="end end">
                <button *ngIf="!notifyMe" matTooltip="Notify me when complete" color="primary" mat-icon-button (click)="notifyMe = true;" [disabled]="loading">
                  <mat-icon>notifications_none</mat-icon>
                </button>
                <button *ngIf="notifyMe" matTooltip="Do not notify me when complete" color="accent" mat-icon-button (click)="notifyMe = false;" [disabled]="loading">
                  <mat-icon>notifications_active</mat-icon>
                </button>
                <button matTooltip="view this situCONNECT configuration" color="primary" mat-flat-button (click)="render();" [disabled]="loading">
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2px">
                      <span>Create situCONNECT</span><mat-icon *ngIf="notifyMe">notifications_active</mat-icon>
                    </div>
                </button>
              </div>
            </div>
            <div>
              <button mat-button matStepperPrevious [disabled]="loading">Back</button>
              <button mat-button (click)="stepper.selectedIndex = 0;" [disabled]="loading">Create another</button>
            </div>
          </mat-step>
        </mat-stepper>
      </mat-card-content>
    </mat-card>
    <div fxFlex="100" fxShow="false" fxShow.lt-md="true" [fxShow.gt-md]="collapsed">
      <situ-connect-config-list
        [viewSituConnectId]="situConnectId"
        (selectedSituConnect)="loadSelectedSituConnect($event);">
      </situ-connect-config-list>
    </div>
  </div>
  <div class="favourites-panel" [fxShow]="!collapsed" fxShow.lt-md="false" fxFlex="35">
    <situ-connect-config-list
      [viewSituConnectId]="situConnectId"
      (selectedSituConnect)="loadSelectedSituConnect($event);">
    </situ-connect-config-list>
  </div>
</div>